import {
  Component,
  Inject,
  OnInit,
  Renderer2,
  ElementRef,
  ViewChild,
  DOCUMENT,
  ChangeDetectionStrategy
} from "@angular/core";
import {
  Router,
  Event,
  NavigationEnd,
  RoutesRecognized,
  
} from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from "./services/auth.service";
import { MasterDataService } from "./services/masterdata.service";
import { UserRolesService } from "./services/user-roles.service";
import { filter, map, mergeMap, pairwise, takeUntil } from "rxjs/operators";
import { Config } from "./config";
import { PageInfo } from "./models/page-info"; 
import $ from "jquery";
import 'bootstrap';
import { TranslateService } from "@ngx-translate/core";
import { MsalBroadcastService } from "@azure/msal-angular";
import { InteractionStatus } from "@azure/msal-browser";
import { LoginService } from "./core/services/login.service"; 
import { OneTrustService } from "./services/one-trust-service";
import { SessionStorageService } from "./core/services/session-storage.service";
import { Modal } from 'bootstrap';
import { LogoutService } from "./core/services/logout.service";
import { AppConfig } from "./design/app";
import { AddSubscription } from '../app/services/add-subscription.service';
import { IApiResponse } from "../app/core/models/api-response.model";

declare var bootstrap: any;


//declare let $: any;
@Component({
    selector: "bizchem-admin",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit {
  title = "bc-admin-new";
  myData: any;
  roleId: number = 0; 
  tab: number;
  showLeftNavigation: boolean = true;
  notCookieNotice: boolean = true;
  isTeamSnapshotComponent: boolean = false;
  userRoleDetails: any;
  userRoleList: Array<any> = [];
  selectedRole: any;
  windowMinWidth: any;
  windowMaxWidth: any;
  omnitureEnvironment: string = "";
  navarea: boolean = true;
  userID: string = "";
  menuDropdown: boolean = false;
  isLoggedin: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  isUserAuthorized:boolean = false;
  showLoaderIcon: boolean = false;
  appConfig: any;
  public subdomains: string[] = [];
  invalidEmailDomain: boolean = false;
  @ViewChild("toggleButton") toggleButton: ElementRef | null = null;
  private myPopupInstance: Modal | null = null;
  constructor(
    private msalBroadcastService: MsalBroadcastService,
    private service: MasterDataService,
    private userRoleService: UserRolesService,
    private router: Router,
    private authService: AuthService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private eRef: ElementRef,
    private translateService: TranslateService,
    private loginService: LoginService,
    private oneTrustService: OneTrustService,
    private sessionStorageService: SessionStorageService,
    private logoutService: LogoutService,
    private addSubscriptionService: AddSubscription,

  ) {
    this.translateService.setDefaultLang("en");
    this.translateService.use("en");
    this.appConfig = AppConfig;
    if (window.location.pathname.indexOf("team-snapshot") > -1) {
      this.isTeamSnapshotComponent = true;
    }
    else {
      this.isTeamSnapshotComponent = false;
    }

    if (!this.isTeamSnapshotComponent) {
      
      this.loadCookieScript();
      this.OptanonWrapper();
      if (window.location.pathname === "/") {
        localStorage.setItem("currentComponent", "/searchSession");
      }
      if (window.location.pathname === '/sessionTimeout') {
        this.router.navigate([""]);     
      }
      this.router.events
        .pipe(
          filter((evt: any) => evt instanceof RoutesRecognized),
          pairwise()
        )
        .subscribe((events: RoutesRecognized[]) => {
          if (events && events.length > 0) {
            localStorage.setItem("currentComponent", events[1].urlAfterRedirects);
            localStorage.setItem("previousUrl", events[0].urlAfterRedirects);
          }
        });

      this._renderer2.listen("window", "click", (e: any) => {
        if (e.target !== this.toggleButton?.nativeElement) {
          this.menuDropdown = false;
        }
      });
    }
    
  }

  ngOnInit() {
    const currentUrl = this.router.url;
    this.navarea = currentUrl === "/searchSession" || currentUrl === "/" || currentUrl === "";
    this.getSubDomains();
    if (!this.isTeamSnapshotComponent) {
      this.loadAppComponent();
    }
  }
  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      console.log('appComponet');

      backdrop.remove();
    }
  }
  loadAppComponent() {
    this.showLoaderIcon = true;
    this.showHideLeftNavigation();
    this.initializeMsalSubscription();

    this.loginService.isLoggedIn$.subscribe((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        this.isLoggedin = true;
        this.userRoleService.getUserRoles().subscribe({
          next: (res: any) => {
            this.showLoaderIcon = false;
            let isRegistered ;
            const domain = res?.Email.split('@')[1];
            if (!this.subdomains.includes(domain)) {
              this.invalidEmailDomain = true; // Domain not in the allowed list
            }
            if (res?.HighestRoleId !== 0 && res?.Roleid.length > 0 && res?.LoggedInUserId > 0) {
              this.isUserAuthorized = true;
              isRegistered = true;
              this.setWinodwWidth();
              this.showHideLeftNavigation();
              this.hideLeftNavigationOnLogout();
            } else {
              isRegistered = false;
            }
            this.userRoleService.setIsUserRegistered(isRegistered);
            this.userRoleService.setIsInvalidDomain(this.invalidEmailDomain);
          },
          error: () => {
            this.showLoaderIcon = false;
          },
        });
      }
    });
  }
  getSubDomains(): void {
    this.addSubscriptionService.getSubDomains()
      .subscribe((res: IApiResponse<string[]>) => {
        if (res.Success) {
          this.subdomains = res.Data;
        }
      }, (error) => {
        console.log(error);
      });
  }
  initializeMsalSubscription(): any {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.loginService.setUserLoginStatus();
      });
  }
  menuIcon() {
    this.menuDropdown = !this.menuDropdown;
  }
  setWinodwWidth() {
    setTimeout(() => {
      const screenWidth = window.innerWidth;
      return (this.windowMinWidth = screenWidth - 30 + "px");
    }, 300);
  }
  onResize(event: any) {
    this.setWinodwWidth();
  }
  onActivate(event: any) {
    this.trackConditionally();

    const scrollToTop = window.setInterval(() => {
      const pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  showHideLeftNavigation() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.showLeftNavigation = true;
        this.navarea = this.router.url === "/searchSession" || this.router.url === "/" || this.router.url === "";
        
        if (this.router.url === "/unauthorised") {
          this.showLeftNavigation = false;
        }
        if (this.router.url === "/cookie-notice") {
          this.showLeftNavigation = false;
          this.notCookieNotice = false;
        }
      }
    });
  }

  onRoleChange(id: any) {
    if (id) {
      this.roleId = id;
      this.userRoleService.userRoleId = this.roleId;
      this.selectedRole = this.roleId;
      this.userRoleService.setUserRoleID(this.roleId);
      this.userRoleService.currentRoleId = this.roleId;
      this.sessionStorageService.setItem('HighestRoleId', this.roleId)
      this.authService.getAuthenticated(this.roleId, this.router.url);
    } else {
      this.router.navigate(["/unauthorised"]);
    }
  }

  onHelpClick() {
   // $("#help_Modal").modal("show");
    const help_Modal = new Modal(document.getElementById('help_Modal'));
    help_Modal.show();

  }

  // Below two functions are for reloading the add-subscription component
  redirectTo(url: string) {
    this.router
      .navigateByUrl("/", { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }

  reload() { 
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
        return false;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/addSubscription']);
  }

  hideLeftNavigationOnLogout() {
    this.userRoleService.getNavigationProperty().subscribe((res) => {
      this.showLeftNavigation = res;
    });
  }

  GetPageName(pageName:any) {
    let currentPage = "";
    if (pageName.includes("editSession")) {
      currentPage = "/editSession";
    } else if (pageName.includes("editSubscription")) {
      currentPage = "/editSubscription";
    } else {
      currentPage = pageName;
    }

    const map = new Map<string, string>();
    map.set("/searchSession", "Session Search");
    map.set("/addSession", "Add Session");
    map.set("/editSession", "Edit Session");
    map.set("/assessment", "Assessment Search");
    map.set("/facilitatorSearch", "Facilitator Search");
    map.set("/resources", "Get Resources");
    map.set("/security", "Security");
    map.set("/addSubscription", "Add Subscription");
    map.set("/searchSubscription", "Subscription Search");
    map.set("/editSubscription", "Edit Subscription");
    map.set("/additionalQuestionsReport", "Additional Questions Report");
    map.set("/dataCleanup", "Data Cleanup");
    map.set("/manageMailBox", "Manage Mailbox");
    map.set("/sessionTimeout", "Session Timeout");
    map.set("/createClient", "Create Client");
    map.set("/searchOrganization", "Search Organization");
    return map.get(currentPage);
  }
  dynamicScriptLoading(pageName: any , userID: string) {
    pageName = this.GetPageName(pageName);
    const script = this._renderer2.createElement("script");
    script.type = "text/javascript";
    const isProduction = this.appConfig.isProduction;
    if (isProduction) {
      script.src = Config.omnitureTrackingProdUrl;
    } else {
      script.src = Config.omnitureTrackingDevUrl;
    }

    this._renderer2.appendChild(this._document.head, script);
    const pageInfo: PageInfo = {
      pageName : pageName,
      userID : userID,
      appName : "Business Chemistry Admin"
    }

    window["analyticsDataLayer"] = {
      pageInfo: pageInfo,
    };
    try {
      window["_satellite"].track("pageView");
    } catch (e) {}
  }

  loadCookieScript() {
    let scriptExists: boolean = false;
    const allscripts = document.getElementsByTagName("script");
    if (allscripts !== null) {
      for (let i = allscripts.length; i >= 0; i--) {
        if (
          allscripts[i] &&
          allscripts[i].src &&
          allscripts[i].src.indexOf(Config.cookiePopupUrl) !== -1
        ) {
          scriptExists = true;
        }
      }
    }

    if (!scriptExists) {
      let guid = "";
      if (
        window.location.host.toLowerCase() !== "businesschemistryadmin.deloitte.com"
      )
        guid = Config.cookieConsentPopupDevGuid;
      else guid = Config.cookieConsentPopupProdGuid;

      const script1 = document.createElement("script");
      script1.src = Config.cookiePopupUrl;
      script1.type = "text/javascript";
      script1.charset = "UTF-8";
      script1.setAttribute("async", "false");
      script1.setAttribute("data-domain-script", guid);
      document.head.appendChild(script1);
    }
  }

  OptanonWrapper() {
    const self = this;
    $(document).on(
      "click",
      ".save-preference-btn-handler,.onetrust-close-btn-handler",
      function () {
        self.trackConditionally();
      }
    );
    $(document).on("click", ".ot-pc-refuse-all-handler", function () {
      window["analyticsDataLayer"] = null;
      self.deleteCookiesOnDecline();
    });
    $(document).on("click", "#onetrust-reject-all-handler", function () {
      window["analyticsDataLayer"] = null;
      self.deleteCookiesOnDecline();
    });
    $(document).on("click", "#onetrust-accept-btn-handler", function () {
      self.trackConditionally();
    });
    $(document).on("click", "#accept-recommended-btn-handler", function () {
      self.trackConditionally();
    });
  }

  trackConditionally() {
   
    if (document.cookie.indexOf("OptanonConsent") > -1) {
      
      const optanon = document.cookie
        .split(";")
        .find((el) => el.indexOf("OptanonConsent") > -1);
      
      const match = optanon?.split("&").find((el) => el.indexOf("groups") > -1);
      if (
        match !== "" &&
        match !== undefined &&
        match !== null &&
        match.charAt(match.length - 1) === "1"
      ) {
        const currentPage = localStorage.getItem("currentComponent");
        this.startTracking(currentPage);
      }
      else {
        this.deleteCookiesOnDecline();
      }
    }
    else {
      this.deleteCookiesOnDecline();
    }
  }

  startTracking(currentPage: string |null ) {
    if (
      this.omnitureEnvironment !== undefined &&
      this.omnitureEnvironment !== null &&
      this.omnitureEnvironment !== "" &&
      this.userID !== undefined &&
      this.userID !== null &&
      this.userID !== ""
    ) {
      this.dynamicScriptLoading(currentPage, this.userID);
    } else {
      this.userRoleService
        .getOmnitureEnvironment()
        .pipe(
          map((res) => {
            if (res) {

              this.omnitureEnvironment = res;
            }
          }),
          mergeMap((params) => this.userRoleService.getLoggedInUserEmail())
        )
        .subscribe((email) => {
          if (email) {
            this.userID = email.slice(0, email.indexOf("@"));
            this.dynamicScriptLoading(currentPage, this.userID);
          }
        });
    }
  }

  gotocookiepolicy() {
    this.oneTrustService.reloadOneTrustBanner();  
    sessionStorage.setItem("iscookiesettingsclicked", "true");
  }
  openCookieNotice() {
    //const baseUrl = window.location.origin;
    //const cookieNoticeUrl = `${baseUrl}/cookie-notice`;
    const cookieNoticeUrl = "https://www2.deloitte.com/us/en/footerlinks1/cookies.html?icid=bottom_cookies";
    window.open(cookieNoticeUrl, '_blank');
  }

  //Kalyani
  public openConfirmationDialog() { 
  //  $("#mypopup").modal({ backdrop: "static", keyboard: false });
  //  $("#mypopup").modal("show"); 
  //  const mypopup = new Modal(document.getElementById('mypopup'));
  //  mypopup.show();
  }

  //Kalyani
  closeConfirmPopUp() { 
   if(this.myPopupInstance) {
      this.myPopupInstance.hide();
    }
  }

  reloadNewSession() {
    this.redirectTo("addSession");
  }

  redirectToFacilitatorSearchPage() {
    
    this.removeBackdrop();
    this.router.navigate(["/facilitatorSearch"]);

  }

  logout() {
    this.logoutService.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  deleteCookiesOnDecline() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const equals = cookies[i].split('=');
                            if (equals[0].match('^ s_') || equals[0].match('^  s_')) {
                                document.cookie = equals[0] + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=deloitte.com";
                            }
                            if (equals[0].match('^ s_') || equals[0].match('^  s_')) {
                                document.cookie = equals[0] + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=.deloitte.com";
                            }
                            if (equals[0].match('^ s_') || equals[0].match('^  s_')) {
                                document.cookie = equals[0] + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
                            }
                        }
  }
}
